import request from "@/utils/request";

export const  gainXjUrl =(query) =>{
    return request({
        url: "/businessservice/eduai/gainXjUrl",
        method:"get",
        params: query
    })
}